/* eslint-disable
	react/jsx-filename-extension,
	react/destructuring-assignment,
	react/jsx-props-no-spreading,
	react/no-unused-state
*/
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { StripeProvider } from 'react-stripe-elements';
import $ from 'jquery';
import { Helmet } from 'react-helmet';

import { isIOS } from 'react-device-detect';
import AsyncLoader from './AsyncComponent';
import Footer from './components/Footer';
import Loading from './components/Loading';
import NotFound from './components/404';
import SpinnerComponent from './components/SpinnerComponent';
import UNAUTHORIZED from './pages/UNAUTHORIZED';
import Verify from './security/Verify';
import VerifyNeeded from './components/VerifyNeeded';
import WithTracker from './WithTracker';

import AjaxHelper from './common/AjaxHelper';
import Constants from './common/Constants';
import SessionHelper from './common/SessionHelper';
import TranslationHelper from './common/TranslationHelper';
import SocketIoHelper from './common/SocketIoHelper';
import DefaultHeader from './components/header/layout/DefaultHeader';
import ResetPassword from './security/ResetPassword';

const AsyncSearchMain = AsyncLoader(() => import('./components/search/SearchMain'));

const AsyncProductTypeMain = AsyncLoader(() => import('./product-type-page/ProductMainWrapper'));

const AsyncStripeMain = AsyncLoader(() => import('./order-new/layout/StripeMainLayout'));
const AsyncOrderConfirmation = AsyncLoader(() => import('./order-new/OrderConfirmation'));
const AsyncRequestBooking = AsyncLoader(() => import('./order-new/requestOrder/RequestBooking'));
const AsyncRequestBookingStripeMain = AsyncLoader(() => import('./order-new/layout/RequestBookingStripeMainLayout'));
const AsyncAuctionStripeMain = AsyncLoader(() => import('./order-new/layout/AuctionStripeMainLayout'));

const AsyncReviewMain = AsyncLoader(() => import('./reviews/ReviewMain'));
const AsyncViewReviewsMain = AsyncLoader(() => import('./reviews/ViewReviewsMain'));
const AsyncViewOrdersMain = AsyncLoader(() => import('./components/orders/layout/ViewOrdersMain'));
const AsyncOrderDetailsMain = AsyncLoader(() => import('./components/orders/components/OrderDetails'));
const AsyncProfileMain = AsyncLoader(() => import('./components/profile/layout/ProfileMain'));
const AsyncMessagingMain = AsyncLoader(() => import('./messaging/MessagingMain'));

const AsyncSellerMain = AsyncLoader(() => import('./seller/SellerMain'));

const PrivacyPolicy = AsyncLoader(() => import('./policies/PrivacyPolicy'));
const TermsAndConditions = AsyncLoader(() => import('./policies/TermsAndConditions'));
const OtherPolicies = AsyncLoader(() => import('./policies/OtherPolicies'));

const AsyncLoginMain = AsyncLoader(() => import('./pages/SignInPage'));
const AsyncSignUpMain = AsyncLoader(() => import('./pages/SignUpPage'));
const AsyncSuccess = AsyncLoader(() => import('./pages/Success'));

const userSession = SessionHelper.getSessionUser();
export const AppRoute = ({
	component: Component, layout: Layout, urlProtected, stripeKey, isLogin, ...rest
}) => (
	<Route
		{...rest}
		render={(props) => (
			<Layout stripeKey={(stripeKey) || null}>
				{ urlProtected && !isLogin
					? <UNAUTHORIZED {...props} />
					: <Component {...props} />}
			</Layout>
		)}
	/>
);

const MainLayout = (props) => (
	<div>
		<DefaultHeader />
		{props.children}
	</div>
);

const HeaderWrapperLayout = (props) => (
	<div>
		<DefaultHeader />
		{props.children}
	</div>
);

const StripeLayout = (props) => (
	<div>
		<DefaultHeader />
		<StripeProvider apiKey={(props.stripeKey) ? props.stripeKey : null}>{props.children}</StripeProvider>
	</div>
);

export const MainLayoutWithoutHeader = (props) => (
	<div className="height100">
		{props.children}
	</div>
);

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			packagesLoaded: false,

			company: {
				name: '',
				email: '',
				address: {
					street: '',
					city: '',
					state: '',
					zip: '',
					country: ''
				},
				phone: '',
				aboutUs: '',
				socialLinks: {
					blog: '',
					facebook: '',
					twitter: '',
					instagram: ''
				},
			},
			policies: {
				TermsandConditions: {
					name: '',
					value: ''
				},
				PrivacyPolicies: {
					name: '',
					value: ''
				},
				OtherPolicies: {
					name: '',
					value: ''
				},
				CopyrightLink: {
					name: '',
					value: ''
				}
			},
			companyName: '',
			companyAboutUs: '',
			companyKeywords: '',
			subscription: '',
			supportedCountries: [],
			isLogin: false,
			loading: true
		};

		let MAP_KEY = SessionHelper.get(Constants.GOOGLE_API_KEY);
		if (!MAP_KEY) {
			AjaxHelper.invokeServerAPI('/api/config', { googleMapAPIKey: 1 }, (err, data) => {
				if (!err) {
					if (!MAP_KEY) {
						MAP_KEY = data.googleMapAPIKey;
						$.getScript(`https://maps.googleapis.com/maps/api/js?key=${MAP_KEY}&libraries=places`, () => {
						});
						SessionHelper.set(Constants.GOOGLE_API_KEY, MAP_KEY);
					}
				}
			});
		}
	}

	async componentDidMount() {
		try {
			await TranslationHelper.loadTranslations();
			const config = await AjaxHelper.invokeServerAPIPromise('/api/config', {
				company: 1,
				'company.name': 1,
				'company.aboutUs': 1,
				'email.auth.user': 1,
				googleMapAPIKey: 1,
				'extanalytics.googleAnalyticsID': 1,
				policies: 1,
				'stripe.publishableKey': 1,
				subscription: 1,
				supportCountries: 1,
				marketplaceType: 1,
				messageServer: 1
			});

			SessionHelper.set(Constants.SESSION_STRIPE_PUB_KEY, config['stripe.publishableKey']);
			SessionHelper.setSupportedCountry(config.supportCountries[0]);

			this.setState({
				stripeKey: config['stripe.publishableKey'],
				packagesLoaded: true,
				company: config.company,
				policies: config.policies,
				email: config['email.auth.user'],
				companyName: `${config['company.name']}`,
				companyAboutUs: config['company.aboutUs'],
				subscription: config.subscription,
				supportedCountries: config.supportCountries,
				messageServer: config.messageServer
			});
		} catch (error) {
			// console.log(error);
		}

		if (userSession) {
			let isLogin;
			try {
				await AjaxHelper.invokeServerAPIPromise('/api/auth/check');
				isLogin = true;
			} catch (e) {
				isLogin = false;
			}
			this.setState({ isLogin, loading: false });
		}
	}

	render() {
		if (SessionHelper.getSessionUser()) {
			if (this.state.loading) return <Loading />;
			if (this.state.messageServer) {
				SocketIoHelper.initialize(this.state.messageServer);
			}
		}

		const final = this.state.packagesLoaded
			? (
				<div className="height100">
					<SpinnerComponent />
					<Switch>
						<AppRoute
							exact
							path="/"
							layout={MainLayoutWithoutHeader}
							component={WithTracker(AsyncSearchMain)}
						/>
						<AppRoute
							exact
							path="/search"
							layout={MainLayoutWithoutHeader}
							component={WithTracker(AsyncSearchMain)}
						/>
						<AppRoute
							exact
							path="/privacy-policy"
							layout={MainLayout}
							component={WithTracker(PrivacyPolicy)}
						/>
						<AppRoute
							exact
							path="/terms-and-conditions"
							layout={MainLayout}
							component={WithTracker(TermsAndConditions)}
						/>
						<AppRoute
							exact
							path="/other-policies"
							layout={MainLayout}
							component={WithTracker(OtherPolicies)}
						/>

						<AppRoute
							exact
							path="/product/:name/:id"
							layout={MainLayoutWithoutHeader}
							component={WithTracker(AsyncProductTypeMain)}
						/>

						<AppRoute
							exact
							path="/messages"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncMessagingMain)}
						/>

						<AppRoute
							exact
							path="/reset-password"
							layout={MainLayoutWithoutHeader}
							component={WithTracker(ResetPassword)}
						/>
						<AppRoute
							exact
							path="/verify"
							layout={MainLayout}
							component={WithTracker(Verify)}
						/>
						<AppRoute
							exact
							path="/verification"
							layout={MainLayout}
							component={WithTracker(VerifyNeeded)}
						/>

						<AppRoute
							exact
							path="/order/confirmation"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncOrderConfirmation)}
						/>

						<AppRoute
							exact
							path="/requestOrder/confirmation"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncRequestBooking)}
						/>

						<AppRoute
							exact
							path="/order"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={StripeLayout}
							component={WithTracker(AsyncStripeMain)}
							stripeKey={this.state.stripeKey}
						/>

						<AppRoute
							exact
							path="/requestOrder"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncRequestBooking)}
						/>
						<AppRoute
							exact
							path="/requestOrder/confirm/:id"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={StripeLayout}
							component={WithTracker(AsyncRequestBookingStripeMain)}
							stripeKey={this.state.stripeKey}
						/>

						<AppRoute
							exact
							path="/auction/payment/:id"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={StripeLayout}
							component={WithTracker(AsyncAuctionStripeMain)}
							stripeKey={this.state.stripeKey}
						/>

						<AppRoute
							exact
							path="/confirmDelivery/:token"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncReviewMain)}
						/>
						<AppRoute
							exact
							path="/orders"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncViewOrdersMain)}
						/>
						<AppRoute
							exact
							path="/orders/:id"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncOrderDetailsMain)}
						/>
						<AppRoute
							exact
							path="/reviews"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncViewReviewsMain)}
						/>
						<AppRoute
							exact
							path="/profile"
							urlProtected
							isLogin={userSession && this.state.isLogin}
							layout={MainLayout}
							component={WithTracker(AsyncViewReviewsMain)}
						/>
						<AppRoute
							exact
							path="/order/confirm/:id"
							layout={MainLayout}
							component={WithTracker(AsyncReviewMain)}
						/>
						<AppRoute
							exact
							path="/profile/view"
							layout={MainLayout}
							urlProtected
							isLogin={userSession && this.state.isLogin}
							component={WithTracker(AsyncProfileMain)}
						/>
						<AppRoute
							exact
							path="/seller/view/:id"
							layout={HeaderWrapperLayout}
							component={WithTracker(AsyncSellerMain)}
						/>

						<AppRoute
							exact
							path="/login"
							urlProtected={false}
							layout={MainLayout}
							component={WithTracker(AsyncLoginMain)}
						/>

						<AppRoute
							exact
							path="/signup"
							urlProtected={false}
							layout={MainLayout}
							component={WithTracker(AsyncSignUpMain)}
						/>

						<AppRoute
							exact
							path="/success"
							urlProtected={false}
							layout={MainLayout}
							component={WithTracker(AsyncSuccess)}
						/>

						<AppRoute
							exact
							path="*"
							layout={MainLayout}
							component={WithTracker(NotFound)}
							packagesLoaded={this.state.packagesLoaded}
						/>
						<AppRoute
							exact
							path="/404"
							layout={MainLayout}
							component={WithTracker(NotFound)}
							packagesLoaded={this.state.packagesLoaded}
						/>

					</Switch>
					<ToastContainer />
				</div>
			)
			:			(
				<Switch>
					<AppRoute exact path="*" layout={MainLayoutWithoutHeader} component={Loading} />
				</Switch>
			);
		return (
			<div className="height100">
				<link rel="stylesheet" type="text/css" href="/stylesheet/style.css" />
				<Helmet>
					{this.state.companyName !== '' && <title>{this.state.companyName}</title>}
					{this.state.companyAboutUs !== '' && (
						<meta
							name="description"
							content={this.state.companyAboutUs}
						/>
					)}
					{this.state.companyKeywords !== '' && <meta name="keywords" content={this.state.companyKeywords} />}
					{isIOS ? <meta name="viewport" content="width=device-width, initial-scale=1.0" /> : null}
				</Helmet>
				<div className="thingsBeforeFooter">
					{final}
				</div>
				{(this.state.company && Object.keys(this.state.company).length)
					? (
						<Footer
							company={this.state.company}
							policies={this.state.policies}
							email={this.state.email}
							subscription={this.state.subscription}
							supportedCountries={this.state.supportedCountries}
						/>
					) : ''}
			</div>
		);
	}
}

export default App;
